import styles from "./newerror.module.css";
import { coneIcon } from "../../utils/svgdata";
import clsx from "clsx";
import { NAVIGATION_ROUTES } from "../../constant";
import { useNavigate } from "react-router-dom";
import paymentFailedIcon from '../../assets/images/verticaltv/payment-failed.png';

type ErrorPageProps = {
  heading?: string;
  title?: string;
  subtitle?: string;
  buttonText?: string;
  orderFailed?: boolean;
}

const ErrorPageNew = ({
  heading = "OOPS!",
  title = "Something went wrong.",
  subtitle = "Don't worry. Lets try again",
  buttonText = "Retry",
  orderFailed = false,
}: ErrorPageProps) => {

    const navigate = useNavigate();

    const handleButtonClick = () => {
        navigate(NAVIGATION_ROUTES.REFERRAL_SUBSCRIPTION_PAYMENT);
    };
   

  return (
    <div className={clsx(styles.main_container, styles.makeblock0d0e11)}>
      <div className={clsx(styles.headerContainer)}>
        
      </div>
      <div className={styles.container}>
        <div className={styles.icon_container}>
          {orderFailed ? <div className={styles.icon_image}><img src={paymentFailedIcon} alt="Payment Failed" /></div> : <div className={styles.icon_image}>{coneIcon}</div>}
        </div>
        <div className={styles.error_heading}>{heading}</div>
        <div className={styles.error_title}>{title}</div>
        <div className={styles.error_title}>{subtitle}</div>
        <div className={clsx(styles.retry_button_container, styles.makegreengredient)} onClick={handleButtonClick}>
          <div className={styles.retry_button_txt}>{buttonText}</div>
        </div>
      </div>
    </div>
  );
};

export default ErrorPageNew;
